import request from '@/utils/request'

// ===================== 你原有接口（不动） =====================

// register
export function registerByEmail(data) {
  return request({
    url: '/auth/register', 
    method: 'post',
    data: data
  })
}

// Login
export function loginByEmail(data) {
  return request({
    url: '/auth/login', 
    method: 'post',
    data: data
  })
}

export function loginByWechat(data) {
  return request({
    url: '/auth/wechat',
    method: 'post',
    data: data
  })
}

// 修改密码
export function changePassword(userId, oldPassword, newPassword) {
  return request({
    url: `/auth/user/${userId}/password`,
    method: 'put',
    data: {
      oldPassword: oldPassword,
      newPassword: newPassword
    }
  })
}

// ===================== 我帮你补齐：忘记密码 + 邮箱验证码 =====================

// 发送邮箱验证码（忘记密码）
export function sendEmailCode(data) {
  return request({
    url: '/auth/send-email-code',
    method: 'post',
    data: data
  })
}

// 重置密码（忘记密码）
export function resetPassword(data) {
  return request({
    url: '/auth/reset-password',
    method: 'post',
    data: data
  })
}

export function getUserInfo() {
  return request({
    url: '/auth/user/info',
    method: 'get'
  })
}